import { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';

const db = firebase.firestore();

/**
 * Modal for deactivating a task template
 * Shows count of open tasks that will be deleted
 */
export function DeactivateTemplateModal({ template, onClose, onConfirm }) {
  const [openTaskCount, setOpenTaskCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    // Count open tasks for this template
    // NEW: Query tasks collection (no isActive field needed)
    const q = db.collection('tasks')
      .where('templateId', '==', template.id)
      .where('status', 'in', ['open', 'overdue']);
    (q.getCountFromServer ? q.getCountFromServer().then(r => r.data().count) : q.get().then(x => x.size))
      .then(count => {
        setOpenTaskCount(count);
        setLoading(false);
      })
      .catch(error => {
        // console statement removed for production
        setLoading(false);
      });
  }, [template.id]);

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // console statement removed for production
      setConfirming(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-danger" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Vorlage deaktivieren</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="delete-warning">
          <i className="fas fa-exclamation-triangle"></i>
          <div>
            <p>
              <strong>Achtung!</strong> Beim Deaktivieren dieser Vorlage werden{' '}
              <strong>
                {loading ? '...' : openTaskCount} offene Aufgabe{openTaskCount !== 1 ? 'n' : ''}
              </strong>{' '}
              gelöscht.
            </p>
            <p>
              Erledigte Aufgaben bleiben als Historie erhalten. Keine neuen Aufgaben werden mehr
              erstellt, bis die Vorlage wieder aktiviert wird.
            </p>
          </div>
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onClose} disabled={confirming}>
            Abbrechen
          </button>
          <button
            type="button"
            className="btn-warning"
            onClick={handleConfirm}
            disabled={loading || confirming}
          >
            {confirming ? 'Deaktiviere...' : 'Deaktivieren'}
          </button>
        </div>
      </div>
    </div>
  );
}
